{
  "create_team_form": {
    "heading": "Create a new team",
    "description": "If you're looking to use SparkLayer on more than one store, teams are a great way to quickly set up a new SparkLayer account. Once set up, you can access any team using your main SparkLayer account details.",
    "company_name_label": "Company name",
    "company_name_description": "This is the company name that will show when accessing this team.",
    "company_website_label": "Company website",
    "company_website_description": "This is the website address of the store associated with the team.",
    "company_website_invalid": "Please enter a valid domain, e.g. example.com",
    "cancel": "Cancel",
    "submit": "Create team"
  }
}
